export default "__VITE_ASSET__BpNWfaRl__"